const SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// birthdayWhen: "Today", "Tomorrow", or the weekday and date of a birthday
// in the coming week.
export function birthdayWhen(daysAway: number, date: string): string {
  if (daysAway === 0) return 'Today'
  if (daysAway === 1) return 'Tomorrow'
  const d = new Date(`${date}T12:00:00Z`)
  const weekday = new Intl.DateTimeFormat('en-GB', { weekday: 'long', timeZone: 'UTC' }).format(d)
  return `${weekday} ${d.getUTCDate()} ${SHORT[d.getUTCMonth()]}`
}

// birthdayMessage is the WhatsApp draft she can send, signed with her first name.
export function birthdayMessage(clientFirst: string, fromName: string, daysAway: number): string {
  const sign = fromName.trim().split(/\s+/)[0]
  const wish = daysAway === 0 ? `Happy birthday, ${clientFirst}!` : `Happy early birthday, ${clientFirst}!`
  return sign ? `${wish} Wishing you a lovely day. ${sign}` : `${wish} Wishing you a lovely day.`
}
